var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"15 18 9 12 15 6"}));
}

ChevronLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-chevron-left"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
